module.exports = __webpack_public_path__ + "media/10no-ten.9f34a983.mp3";